import { IExpressNotificationListItem } from "./express-notifications.reducer";

export const actionTypes = {
  SET_EXPRESS_NOTIFICATION_LIST: "SET_EXPRESS_NOTIFICATION_LIST",
  APPEND_EXPRESS_NOTIFICATION_LIST: "APPEND_EXPRESS_NOTIFICATION_LIST",
};

const setExpressNotificationList = (payload: IExpressNotificationListItem[]) => ({
  type: actionTypes.SET_EXPRESS_NOTIFICATION_LIST,
  payload,
});

const appendExpressNotificationList = (payload: IExpressNotificationListItem[]) => ({
  type: actionTypes.APPEND_EXPRESS_NOTIFICATION_LIST,
  payload,
});

export default {
  setExpressNotificationList,
  appendExpressNotificationList,
};
